// Bingo Bango Bongo — three points per hole, tracked live in
// GolfGamesScorecard (bingo = first on green, bango = closest once all on,
// bongo = first in the hole). calcBingoBangoBongo just sums those pre-tracked
// points; here we compute the same total from per-hole events (1 pt each),
// then rank high-first — identical result to the live sum.
export function computeBbb(players, eventsByHole = []) {
  const pts = {}
  ;(players || []).forEach((p) => { pts[p.id] = 0 })
  ;(eventsByHole || []).forEach((e) => {
    if (!e) return
    for (const k of ['bingo', 'bango', 'bongo']) {
      if (e[k] != null && pts[e[k]] != null) pts[e[k]] += 1
    }
  })
  return (players || [])
    .map((p) => ({ ...p, points: pts[p.id] || 0 }))
    .sort((a, b) => b.points - a.points)
}
